import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { CategoriaApiService } from "./shared/categoria-api.service";
import { CategoriaListComponent } from './categoria-list/categoria-list.component';
import { CategoriasComponent } from "./categorias.component";
import { CategoriasRoutingModule } from "./categorias-routing.module";
import { CategoriaNavigationService } from "./shared/categoria-navigation.service";
import { BemTiposModule } from "../bem-tipos/bem-tipos.module";
import { BemSubtiposModule } from "../bem-subtipos/bem-subtipos.module";
import { CategoriaFormComponent } from "./categoria-form/categoria-form.component";

@NgModule({
  imports: [
    SharedModule,
    BemTiposModule,
    BemSubtiposModule,
    CategoriasRoutingModule
  ],
  providers:[
    CategoriaApiService,
    CategoriaNavigationService
  ],
  declarations: [
    CategoriasComponent,
    CategoriaListComponent,
    CategoriaFormComponent
  ]
})
export class CategoriasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/categorias.module.ts
 **/